export default __webpack_public_path__ + "static/media/calla_lily.b619d6f7.png";